import React from 'react';
import MusicAlbumFirstPageRegistrationForm from './MusicAlbumFirstPageRegistrationForm';
import MusicAlbumFirstPageNextButton from './MusicAlbumFirstPageNextButton';

export default function MusicAlbumFirstPage({
  isLoggingIn,
} : {
  isLoggingIn: boolean,
}) {
  return (
    <>
      {isLoggingIn && (
        <form className="cake_ajax_form">
          <MusicAlbumFirstPageNextButton
            onClick={() => {
              document.location.href = '/music_albums';
            }}
          />
        </form>
      )}
      {!isLoggingIn && (
        <MusicAlbumFirstPageRegistrationForm />
      )}
    </>
  );
}
